import { render } from "./RecentEvents.vue?vue&type=template&id=ad9a3658"
import script from "./RecentEvents.vue?vue&type=script&lang=js"
export * from "./RecentEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__